import axios from "axios";
import _ from "lodash";
import React from "react";
import queryString from "query-string";
import { Redirect } from "react-router-dom";
import { getCookie, removeAllCookies } from "../../utils/cookies";
import {
  refreshAccessToken,
  refreshAccountToken,
} from "../accountApp/authService";
import { saveLogs } from "../../utils/firebase/logs";
import firebase from "firebase";
import { verifyAuthTokenWithServer } from "../authService";
const baseUrl = process.env.REACT_APP_API_ENDPOINT;
const options = {
  baseUrl: baseUrl,
};
export const axiosClient = axios.create(options);
function removeQueryParam(url, param) {
  var urlParts = url.split("?");
  if (urlParts.length >= 2) {
    var prefix = encodeURIComponent(param) + "=";
    var queryParams = urlParts[1].split(/[&;]/g);
    // Iterate through query parameters
    for (var i = queryParams.length; i-- > 0; ) {
      // Remove param if found
      if (queryParams[i].lastIndexOf(prefix, 0) !== -1) {
        queryParams.splice(i, 1);
      }
    }
    // Reconstruct the URL
    url =
      urlParts[0] + (queryParams.length > 0 ? "?" + queryParams.join("&") : "");
  }
  return url;
}

const handleRedirect = () => {
  let params = new URLSearchParams(window.location.search);

  // Delete the foo parameter.
  params.delete("t");

  // now join the query param and host
  var outputUrl = removeQueryParam(window.location.href, "t");

  const interval = setInterval(() => {
    const idToken = getCookie("idToken");
    if (idToken) {
      window.location.href = outputUrl;
    }
  }, 500);

  return () => clearInterval(interval);
};
const handleLogout = () => {
  firebase
    .auth()
    .signOut()
    .then(() => {
      removeAllCookies();
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`;
    })
    .catch((error) => {});
};

const handleLogin = async (firebaseUser) => {
  const idToken = await firebaseUser.getIdToken(true);
  verifyAuthTokenWithServer(idToken, firebaseUser);
  return idToken;
};
axiosClient.interceptors.response.use(
  (response) => {
    if (
      response.status >= 200 &&
      response.status < 300 &&
      response.data.status >= 200 &&
      response.data.status <= 300
    ) {
      const config = response.config;
      if (config.method === "post" || config.method === "get") {
        const { body, logAppName, locationId } = config;
        if (body && logAppName && locationId) {
          body.code = body.code || "create";
          saveLogs(body, logAppName, locationId);
        }
      } else if (config.method === "patch" || config.method === "put") {
        const { body, logAppName, locationId } = config;
        if (body && logAppName && locationId) {
          body.code = body.code || "update";

          saveLogs(body, logAppName, locationId);
        }
      } else if (config.method === "delete") {
        const { body, logAppName, locationId } = config;
        if (body && logAppName && locationId) {
          body.code = body.code || "delete";

          saveLogs(body, logAppName, locationId);
        }
      }
    }
    return response;
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        const isAppEmbedded = queryString.parse(
          window.location.search,
        ).isAppEmbedded;
        try {
          const res = await refreshAccountToken();
          const { idToken: customToken } = res?.data;
          if (res.status !== 200) {
            handleLogout();
          } else {
            const userCredential = await firebase
              .auth()
              .signInWithCustomToken(customToken);
            const idToken = await handleLogin(userCredential.user);
            // const refreshToken = getCookie("refreshToken");
            // const { id_token } = await refreshAccessToken(refreshToken);
            if (!_.isEmpty(idToken)) {
              let updatedConfig = {
                ...error.config,
                headers: {
                  ...error.config.headers,
                  Authorization: `Bearer ${idToken}`,
                },
              };
              return axios(updatedConfig);
            } else {
              if (isAppEmbedded !== "true") {
                return (window.location.href = `${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`);
              }
            }
          }
        } catch (error) {
          if (isAppEmbedded !== "true") {
            return (
              <Redirect
                to={`${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`}
              />
            );
          }
        }
      }
    } else {
      // redirect to login
      return (
        <Redirect
          to={`${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`}
        />
      );
    }
    return Promise.reject(error);
  },
);
axiosClient.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (config.url.includes("securetoken.googleapis.com/v1/token")) {
      return config;
    }
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${getCookie("idToken")}`,
    };
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);